import styled, { css } from 'styled-components';

import { TextareaStyled, InputStyled, RowStyled } from '~/Components/Styled';
import { FormGroup as FormGroupStyled } from '../../styles';


export const FormGroup = styled(FormGroupStyled)`
  > label{
    > span {
      color: ${props => props.theme.colors.danger2};
      font-weight: normal;
      font-size: 20px;
    }
  }
`;

export const Input = styled(InputStyled)`
  margin-right: 0;
`;

export const Textarea = styled(TextareaStyled)`
  width: 100%;
  resize: vertical;
`;

export const ContainerTabs = styled.div`
  display: flex;
  justify-content: space-between;

  .react-tabs {
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    flex-direction: column;
    color: ${props => props.theme.colors.primary};
  }

  .react-tabs__tab-list {
    margin-bottom: 0;
    border-bottom: none;
  }

  .react-tabs__tab {
    border-color: ${props => props.theme.colors.light};
    border-bottom: 3px solid ${props => props.theme.colors.light};
    font-size: 24px;
    color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.lighterWhite};
  }

  .react-tabs__tab.react-tabs__tab--selected {
    border-radius: 0;
    border-bottom: 3px solid #fff;
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.primary};
  }

  .react-tabs__tab-panel--selected {
    display: flex;
    width: 100%;
    border-radius: 0 8px 8px 8px;
    border: solid 1px ${props => props.theme.colors.light};
    align-items: flex-start;
    justify-content: flex-start;
    .tab-body {
      padding: 15px;
      flex: 1;
      display: flex;
      flex-direction: column;
      width: calc(100% - 30px);
      flex-shrink: 0;
      background-color: ${props => props.theme.colors.bgBody};
    }
  }
`;

export const Row = styled(RowStyled)`
  justify-content: space-between;
  .title-separator {
    margin-top: 20px;
    border-bottom: 1px solid ${props => props.theme.colors.primary};
    width: 100%;
  }
`;

export const Imagem = styled.div`
  padding: 20px;
  border: solid 2px ${props => props.theme.colors.light};
  border-radius: 4px;
  position: relative;

  .success-img {
    max-width: 150px;
    position: relative;
  }

  ${props => props.invalid
    && css`
      border-color: ${props.theme.colors.danger2};
    `}
`;

export const BannerEmpty = styled.div`
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
`;

export const ErrorMessage = styled.span`
  color: ${props => props.theme.colors.danger2};
  font-style: italic;
`;
